@import '../../../../styles/teamscale_variables';

.ui-debugger-segment {
	position: absolute !important;
	width: 750px;
	background: white !important;
	bottom: 0;
	right: 310px;
	padding: 10px !important;
	max-height: 500px;
	overflow: auto;
	z-index: 9999;
	height: auto !important;
}

.hoverDim {
	opacity: 0.5;

	&:hover {
		opacity: 1;
	}
}

.tabHeaders {
	color: @tsMainColor;
	text-decoration: none;
	border-bottom: 1px solid #999;
	margin-bottom: 6px;
	padding-bottom: 6px;
	display: flex;
	align-items: center;
	gap: 3px;

	& > strong {
		margin-right: auto;
	}

	button {
		all: unset;
		color: #999;
		cursor: pointer;
		width: 20px;
		height: 20px;

		&:hover,
		&.active {
			color: @tsMainColor;
		}
	}
}
